"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentValueValidationResultMetadataSchema = exports.ComponentValueValidationInstanceMetadataSchema = exports.ComponentValueValidationPackageDataSchema = exports.ComponentValueValidationDesignDataSchema = exports.ComponentValueValidationResultKey = exports.ComponentValueValidationRequirementTypeId = void 0;
exports.getDrawPropertyValues = getDrawPropertyValues;
const zod_1 = require("zod");
const metadata_1 = require("../../DesignModels/metadata");
const ModuleDrawProperty_1 = require("../../DesignModels/DrawingModels/ModuleDrawProperty");
exports.ComponentValueValidationRequirementTypeId = 'CVAL';
exports.ComponentValueValidationResultKey = 'ComponentValueValidationResult';
exports.ComponentValueValidationDesignDataSchema = zod_1.z.object({
    value: zod_1.z.string().optional(),
    metadata: metadata_1.MetadataSchema.optional(),
    drawProperties: zod_1.z.record(zod_1.z.string(), ModuleDrawProperty_1.ModuleDrawPropertySchema).optional(),
});
function getDrawPropertyValues(drawProperties) {
    if (!drawProperties) {
        return undefined;
    }
    const filteredProps = Object.entries(drawProperties).filter(([, prop]) => !prop.hidden);
    return Object.fromEntries(filteredProps.map(([key, prop]) => [
        key,
        {
            value: prop.value,
        },
    ]));
}
exports.ComponentValueValidationPackageDataSchema = zod_1.z.object({
    resolutionType: zod_1.z.string().optional(),
    value: zod_1.z.string().optional(),
    manufacturer: zod_1.z.string().optional(),
    partNumber: zod_1.z.string().optional(),
});
exports.ComponentValueValidationInstanceMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal(exports.ComponentValueValidationResultKey),
    referenceDesignator: zod_1.z.string(),
    designData: exports.ComponentValueValidationDesignDataSchema,
    packageData: exports.ComponentValueValidationPackageDataSchema,
});
exports.ComponentValueValidationResultMetadataSchema = zod_1.z.object({
    type: zod_1.z.literal(exports.ComponentValueValidationResultKey),
    message: zod_1.z.string(),
    packageRawValue: zod_1.z.string(),
    projectRawValue: zod_1.z.string(),
    packageValue: zod_1.z.string(),
    projectValue: zod_1.z.string(),
});
//# sourceMappingURL=ComponentValueValidationInstanceMetadata.js.map